import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {subscriptionPlan} from "@/store/modules/subscriptionPlan.ts";
import {RootState} from "@/store";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";
import {CreateWorkspaceRequest} from "@/model/request/workspace/CreateWorkspaceRequest.ts";
import {useNavigate} from "react-router-dom";
import {RouteConstant} from "@/util/constant/RouteConstant.ts";
import BaseButton from "../buttons/BaseButton.tsx";
import {workspace} from "@/store/modules/workspace.ts";
import NavBarHeading from "@/components/menu/NavBarHeading.tsx";


export default function BillingComponent() {

    const dispatch = useDispatch<any>();
    const workspaceState = useSelector((state: RootState) => state.workspace);
    const [subPlan, setSubPlan] = useState<string>("");

    useEffect(() => {
        dispatch(subscriptionPlan.action.read())
    }, []);

    const navigate = useNavigate();

    const showMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
        );
    };


    const handleOnClick = async (id: number, value?: CreateWorkspaceRequest) => {
        setSubPlan(id as unknown as string)
        const request = {
            ...value,
            workspaceName: workspaceState.CreateWorkSpaceBilling.workspaceName,
            workspaceDescription: workspaceState.CreateWorkSpaceBilling.workspaceDescription,
            workspaceSubscriptionPlanId: id
        };
        await dispatch(
            workspace.action.create({
                data: request,
                onSuccess: (response: any) => showMessage(response),
                onError: (response: any) => showMessage(response),
            })
        );
        navigate(RouteConstant.dashboard.dashboard.path)

    };

    const SubscriptionPlanState = useSelector((state: RootState) => state.subscriptionPlan);
    const icon = "✔";

    return (
            <section id="AppContent" className="app-content-bill">
                <div className="title-wrapper">
                    <div className="margin-bottom margin-xsmall">
                        <h5 className="bill" style={{marginLeft: "-120px"}}>Workspace Subscription</h5>
                    </div>
                    <p className="paragraph" style={{marginLeft: "80px"}}>
                        <NavBarHeading/>
                    </p>
                </div>
                <section>
                    <div className="sub-flex">
                        {SubscriptionPlanState.subscriptionPlan.map((item) => (
                            <div className="sub-card">
                                <div className="sub-card-title">
                                    {item.subscriptionPlanName}
                                </div>
                                <div className="margin-vertical margin-xsmall">
                                    <div className="pricing22_top-row-price">${item.subscriptionPlanPrice}<span
                                        className="pricing22_top-row-price-month">/mo</span>
                                    </div>
                                </div>
                                <ul>
                                    <li>
                                        {icon} Maximum of {item.subscriptionPlanMaximumSeat} seats
                                    </li>
                                    <li>
                                        {icon} {item.subscriptionPlanCodeDeploymentPerMonth} Code Deployment Per Month
                                    </li>
                                    <li>
                                        {icon} {item.subscriptionPlanCodeExportPerMonth} Code Export Per Month
                                    </li>
                                    <li>
                                        {icon} {item.subscriptionPlanCustomCode} Custom Code
                                    </li>
                                </ul>
                                <BaseButton name={"Add Workspace"}
                                            onClick={() => handleOnClick(item.subscriptionPlanId)}
                                            loading={Number(subPlan) == item.subscriptionPlanId && workspaceState.loading}/>
                            </div>
                        ))}
                    </div>
                </section>
            </section>
    );
}
